import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import CustomNavbar from './components/CustomNavbar/CustomNavbar';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer/Footer'; 
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import PropertyDetails from './pages/PropertyDetails/PropertyDetails';
import CategoryPage from './pages/CategoryPage/CategoryPage';
import NotFound from './pages/NotFound/NotFound'; 
import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <div className="App">
        <CustomNavbar />
        <ScrollToTop />

        <div className="main-content">
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/property/:id" element={<PropertyDetails />} />
            <Route path="/properties/:type/:status" element={<CategoryPage />} />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;